/* Refillia: lo switch tra le collezioni */
(function () {
  // le schede di un pannello nascosto arrivano dal template la prima volta che serve
  function apri(pannello) {
    var t = pannello.querySelector('template[data-rf-dopo]');
    if (t) pannello.replaceChild(t.content, t);
  }
  function avvia(sez) {
    if (sez.dataset.rfPronta) return;
    sez.dataset.rfPronta = '1';
    var bottoni = sez.querySelectorAll('[data-rf-tab]');
    var pannelli = sez.querySelectorAll('[data-rf-pannello]');
    for (var i = 0; i < bottoni.length; i++) {
      (function (b) {
        // al passaggio del mouse le schede si preparano in anticipo, così il clic è immediato
        b.addEventListener('pointerenter', function () {
          var p = sez.querySelector('[data-rf-pannello="' + b.dataset.rfTab + '"]');
          if (p) apri(p);
        }, { once: true });
        b.addEventListener('click', function () {
          var n = b.dataset.rfTab;
          for (var j = 0; j < bottoni.length; j++) {
            var on = bottoni[j] === b;
            bottoni[j].classList.toggle('rf-swatch__b--on', on);
            bottoni[j].setAttribute('aria-selected', on ? 'true' : 'false');
          }
          for (var k = 0; k < pannelli.length; k++) {
            var acceso = pannelli[k].dataset.rfPannello === n;
            if (acceso) apri(pannelli[k]);
            pannelli[k].classList.toggle('rf-vetrina__griglia--via', !acceso);
          }
        });
      })(bottoni[i]);
    }
  }
  // la linea sotto le collezioni segue lo scorrimento, così si capisce che scorrono
  function linea(sez) {
    var riga = sez.querySelector('.rf-swatch'), barra = sez.querySelector('[data-rf-scorri]');
    if (!riga || !barra || barra.dataset.rfPronta) return;
    barra.dataset.rfPronta = '1';
    var cursore = barra.querySelector('i');
    function aggiorna() {
      var tot = riga.scrollWidth, vis = riga.clientWidth;
      barra.hidden = tot <= vis + 2;
      if (barra.hidden) return;
      var w = Math.min(0.25, 120 / Math.max(1, barra.clientWidth)), x = riga.scrollLeft / (tot - vis);
      cursore.style.width = (w * 100) + '%';
      cursore.style.left = (x * (1 - w) * 100) + '%';
    }
    riga.addEventListener('scroll', aggiorna, { passive: true });
    window.addEventListener('resize', aggiorna);
    barra.addEventListener('click', function (e) {
      var r = barra.getBoundingClientRect();
      riga.scrollTo({ left: (e.clientX - r.left) / r.width * (riga.scrollWidth - riga.clientWidth), behavior: 'smooth' });
    });
    aggiorna();
    // un piccolo accenno di scorrimento la prima volta che la sezione si vede
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (v) {
        if (!v[0].isIntersecting) return;
        io.disconnect();
        if (riga.scrollWidth <= riga.clientWidth + 2 || riga.scrollLeft > 0) return;
        riga.scrollTo({ left: 60, behavior: 'smooth' });
        setTimeout(function () { riga.scrollTo({ left: 0, behavior: 'smooth' }); }, 700);
      }, { threshold: 0.6 });
      io.observe(riga);
    }
  }
  function tutte() {
    var l = document.querySelectorAll('[data-rf-vetrina]');
    for (var i = 0; i < l.length; i++) { avvia(l[i]); linea(l[i]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
  else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
